import React, { useMemo } from "react";
import { Card } from "react-bootstrap";
import { Location } from "../../types/Types";
import { getCountryFlag } from "../../util/Util";
import { Link } from "react-router-dom";

interface Props {
    locations: Location[];
    socialDisabled: boolean;
}

interface CountryData {
    country: string;
    flag: string | React.ReactElement;
    count: number;
}

function CountriesWidget(props: Props) {
    const countriesData = useMemo(() => {
        const countryMap: { [key: string]: number } = {};
        
        props.locations.forEach(location => {
            // Only count enabled pubs (exclude hidden pubs)
            if (location.country && (location.enabled === undefined || location.enabled)) {
                countryMap[location.country] = (countryMap[location.country] || 0) + 1;
            }
        });

        const data: CountryData[] = Object.entries(countryMap)
            .map(([country, count]) => ({
                country,
                flag: getCountryFlag(country),
                count
            }))
            .sort((a, b) => b.count - a.count);

        return data;
    }, [props.locations]);

    if (!props.locations || props.locations.length === 0) {
        return (
            <Card className="mb-3">
                <Card.Header>
                    <div><b>Countries and Territories</b></div>
                </Card.Header>
                <Card.Body style={{ padding: "1em" }}>
                    <div className={'loading'}>Loading...</div>
                </Card.Body>
            </Card>
        );
    }

    return (
        <Card className="mb-3">
            <Card.Header>
                <div><b>Countries and Territories</b></div>
            </Card.Header>
            <Card.Body style={{ padding: "1em" }}>
                <ul className={"bullet-points"}>
                    {countriesData.map(({ country, flag, count }) => (
                        <li key={country}>
                            <div className={"mb-2"}>
                                <span style={{ fontSize: '1.2em', marginRight: '0.5em' }}>{flag}</span>
                                <span>{country}: </span>
                                <Link to={`/pubs?search=${encodeURIComponent(country)}`}>
                                    <b>{count}</b> {count === 1 ? 'pub' : 'pubs'}
                                </Link>
                            </div>
                        </li>
                    ))}
                </ul>
            </Card.Body>
        </Card>
    );
}

export default CountriesWidget;
